/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Group_WarningsInputs */

const en_doc_group_warnings = /** @type {(inputs: Doc_Group_WarningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warnings`)
};

const pt_br2_doc_group_warnings = /** @type {(inputs: Doc_Group_WarningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avisos`)
};

/**
* | output |
* | --- |
* | "Warnings" |
*
* @param {Doc_Group_WarningsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const doc_group_warnings = /** @type {((inputs?: Doc_Group_WarningsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Group_WarningsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_group_warnings(inputs)
	return pt_br2_doc_group_warnings(inputs)
});